/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */

 /** Core [[StateManager]] states. */
export enum StateID
{
    Initializing,
    CheckRecall,
    CheckRecovery,
    PostInitializing,
    Recover,
    WaitForPlay,
    Request,
    Spinning,
    Bonus,
    Award,
    WinCelebration,
    PostPlay,
    Effect,
    Custom,
    Loading
}
